import React from "react";
import { SlidePages } from "../../components/slidePages";
import { BlogList } from "../../components/blogListe";
import { Partenaire } from "../../components/home/nosPartenaire";

export const BlogPage = () => {
  return (
    <div>
      <SlidePages
        title={"Conseils & actualités en rénovation énergétique"}
        description={
          "Découvrez nos articles pour mieux comprendre les enjeux de la rénovation énergétique, les aides disponibles, les choix techniques (ITE, ITI, ravalement, toiture…) et les obligations légales."
        }
      />
      <BlogList />
      <Partenaire />
    </div>
  );
};
